module.exports = __webpack_public_path__ + "static/img/1-3.a95ca71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/1-3.png
// module id = 3Dj1
// module chunks = 1